/**
 * Maps module-order item names (from API) to route and display config for the left sub-menu.
 * Key = normalized itemName (lowercase, trim). Used for librariesGroupsTemplates module.
 */
/** activeClassList for MenuItem (active state paths); menuIconClass for dropdown/mobile menu. */
export const LIBRARIES_MENU_ITEM_MAP = {
  'colours/artwork': {
    path: '/libraries/colour-library',
    activeClassList: ['/libraries/colour-library', '/colour-groups', '/colour-group'],
    titleKey: 'SUB_HEADER.COLOURS_ARTWORK',
    iconClass: 'icon-colours',
    menuIconClass: 'icon-Lib-Colour-Pallette',
    permissionKey: 'colours',
  },
  bom: {
    path: '/libraries/bom-type',
    activeClassList: ['/libraries/bom-type'],
    titleKey: 'SUB_HEADER.BOM',
    iconClass: 'icon-bom',
    menuIconClass: 'icon-Lib-BOM',
    permissionKey: 'bom',
  },
  pom: {
    path: '/libraries/point-of-measures',
    activeClassList: ['/libraries/point-of-measures', '/pom-groups', '/gradings'],
    titleKey: 'SUB_HEADER.POM_GRADINGS',
    iconClass: 'icon-pom_n_gradient',
    menuIconClass: 'icon-Inside-Measurements',
    permissionKey: 'pomGrading',
  },
  'spec templates': {
    path: '/libraries/spec-template',
    activeClassList: ['/libraries/spec-template'],
    titleKey: 'SUB_HEADER.SPEC_TEMPLATES',
    iconClass: 'icon-specs_template',
    menuIconClass: 'icon-Lib-Spec-Template-Icon',
    permissionKey: 'spec',
  },
  'care/user labels': {
    path: '/libraries/care-user-instruction',
    activeClassList: ['/libraries/care-user-instruction', '/care-group'],
    titleKey: 'USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.USER_INSTRUCTION',
    iconClass: 'icon-specs_template',
    menuIconClass: 'icon-User-Instructions',
    permissionKey: 'CareUserInstruction',
  },
  'care/user instructions': {
    path: '/libraries/care-user-instruction',
    activeClassList: ['/libraries/care-user-instruction', '/care-group'],
    titleKey: 'USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.USER_INSTRUCTION',
    iconClass: 'icon-specs_template',
    menuIconClass: 'icon-User-Instructions',
    permissionKey: 'CareUserInstruction',
  },
  'control library': {
    path: '/libraries/control-library',
    activeClassList: ['/libraries/control-library'],
    titleKey: 'SUB_HEADER.CONTROL_LIBRARY',
    iconClass: 'icon-Module',
    menuIconClass: 'icon-Module',
  },
  'additional information': {
    path: '/libraries/custom-module/library',
    activeClassList: ['/libraries/custom-module/library', 'custom-module/group'],
    titleKey: 'SUB_HEADER.ADDITIONAL_INFORMATION',
    iconClass: 'icon-custom_asset_new',
    menuIconClass: 'icon-Lib-Custom-Modules',
    permissionKey: 'customModule',
    rightKey: 'customModuleRight',
  },
  dpp: {
    path: '/libraries/dpp',
    activeClassList: ['/libraries/dpp'],
    titleKey: 'SUB_HEADER.DPP',
    iconClass: 'icon-custom_asset_new',
    menuIconClass: 'icon-Lib-DPP',
    permissionKey: 'dpp',
    rightKey: 'DPPRight',
  },
  testing: {
    path: '/libraries/testing',
    activeClassList: ['/libraries/testing'],
    titleKey: 'SUB_HEADER.TESTING',
    iconClass: 'icon-testing',
    menuIconClass: 'icon-Lib-Testing',
    permissionKey: 'testing',
    rightKey: 'TestingRight',
  },
  'po templates': {
    path: '/libraries/purchase-order-template',
    activeClassList: ['/libraries/purchase-order-template'],
    titleKey: 'SUB_HEADER.PO_TEMPLATES',
    iconClass: 'icon-create_po',
    menuIconClass: 'icon-Lib-Purchase-Order-Preview',
    permissionKey: 'poTemplate',
    rightKey: 'purchaseOrderRight',
  },
  'purchase order': {
    path: '/libraries/purchase-order-template',
    activeClassList: ['/libraries/purchase-order-template'],
    titleKey: 'SUB_HEADER.PO_TEMPLATES',
    iconClass: 'icon-create_po',
    menuIconClass: 'icon-Lib-Purchase-Order-Preview',
    permissionKey: 'poTemplate',
    rightKey: 'purchaseOrderRight',
  },
  'costing templates': {
    path: '/libraries/costing-template',
    activeClassList: ['/libraries/costing-template'],
    titleKey: 'SUB_HEADER.COSTING_TEMPLATE',
    iconClass: 'icon-new-costing-template',
    menuIconClass: 'icon-Lib-costing',
    permissionKey: 'costingTemplate',
    rightKey: 'productCostingRight',
  },
  'freight & duty': {
    path: '/libraries/freight-duty',
    activeClassList: ['/libraries/freight-duty'],
    titleKey: 'SUB_HEADER.FREIGHT_AND_DUTY',
    iconClass: 'icon-freight_new',
    menuIconClass: 'icon-Lib-Freight-and-duty',
    permissionKey: 'freight',
    rightKey: 'frieghtRight',
  },
  'asset library': {
    path: '/libraries/asset-library',
    activeClassList: ['/libraries/asset-library'],
    titleKey: 'ASSET_LIBRARY.SYSTEM_MASTER_TAB',
    iconClass: 'icon-DAM-1',
    menuIconClass: 'icon-DAM-1',
  },
  'care labels': {
    path: '/libraries/care/symbol',
    activeClassList: ['/libraries/care/symbol'],
    titleKey: 'SUB_HEADER.CARE_LABELS',
    iconClass: 'icon-care_labels',
    menuIconClass: 'icon-care_labels',
    permissionKey: 'care',
  },
};

/** Normalize item name for lookup (lowercase, trim). */
export function normalizeItemName(name) {
  return (name || '').toLowerCase().trim();
}

/**
 * Maps Reports module-order item names to todo-list tab type.
 * Used to sort todo-list left menu items by module order config sequence.
 * Key = normalized itemName from config; value = tab.type in todoListTabs.
 */
export const REPORTS_MENU_TYPE_MAP = {
  'progress indicator': 'progress-indicator',
  'sample request': 'samples',
  'supplier to do': 'supplier-todo',
  'supplier suggestions': 'suggestion',
  costing: 'costing',
  'submit & download': 'submit-download',
  testing: 'testing',
  'purchase order': 'product-purchase-order-todo',
};

/**
 * Build a map of tab type → sequence (0-based) from reports module order config.
 * Tabs not in config get sequence 999 so they appear at the end.
 */
export function getReportsSequenceByType(moduleOrderConfigs) {
  const config = (moduleOrderConfigs || []).find((c) => c.moduleId === 'reports');
  const items = config?.items ? [...config.items].filter((i) => i.isActive !== false).sort((a, b) => (a.sequence || 0) - (b.sequence || 0)) : [];
  const sequenceByType = {};
  items.forEach((item, index) => {
    const key = normalizeItemName(item.itemName);
    const type = REPORTS_MENU_TYPE_MAP[key];
    if (type !== undefined) sequenceByType[type] = index;
  });
  return sequenceByType;
}

/**
 * Product Information (development-order-overview) left menu.
 * itemName → { path, activeClassList, titleKey, iconClass, permissionKey, rightKey? }.
 */
export const PRODUCT_INFORMATION_MENU_ITEM_MAP = {
  products: {
    path: '/development-order-overview',
    activeClassList: ['/development-order-overview'],
    titleKey: 'PLACEHOLDER_URL.PRODUCTS',
    iconClass: 'icon-Main-Products',
    permissionKey: 'products',
  },
  planning: {
    path: '/planning/planning-actual',
    activeClassList: ['/planning/planning-actual', '/planning/planning-bottomup'],
    titleKey: 'PLACEHOLDER_URL.PLANNING',
    iconClass: 'icon-Product-Planning',
    permissionKey: 'planning',
    rightKey: 'planningTopsDownRightOrBottomUp',
    linkResolver: (sectionAccess, planningTopsDownRight) =>
      sectionAccess?.planning?.topDownAccess && planningTopsDownRight ? '/planning/planning-actual' : '/planning/planning-bottomup',
  },
  'placeholder management': {
    path: '/placeholder-management',
    activeClassList: ['/placeholder-management'],
    titleKey: 'PLACEHOLDER_URL.PLACEHOLDER_MANAGEMENT',
    iconClass: 'icon-Product-Placeholder-Management',
    permissionKey: 'placeholder',
    rightKey: 'placeholderRight',
  },
  'range plan': {
    path: '/rangeplan/card-view',
    activeClassList: ['/rangeplan/card-view', '/rangeplan/add', '/rangeplan/edit', '/rangeplan/product-list', '/rangeplan/archived'],
    titleKey: 'PLACEHOLDER_URL.RANGE_PLAN',
    iconClass: 'icon-Product-Range-Plan-Icon',
    permissionKey: 'rangePlan',
    rightKey: 'rangePlanRight',
  },
  'critical paths': {
    path: '/product-cp',
    activeClassList: ['operational-cp', '/product-cp'],
    titleKey: 'PLACEHOLDER_URL.CRITICAL_PATHS',
    iconClass: 'icon-Product-Critical-Path',
    permissionKey: 'criticalPath',
    rightKey: 'productCriticalPathRightOrOperational',
    linkResolver: (sectionAccess, isSupplierLoggedIn, operationalCriticalPathRight) =>
      sectionAccess?.criticalPath?.operationalAccess && !isSupplierLoggedIn && operationalCriticalPathRight ? '/operational-cp' : '/product-cp',
  },
};

/**
 * Products (development-order/:id) left menu. pathSuffix is appended to /development-order/:devOrderId/
 */
export const PRODUCTS_MENU_ITEM_MAP = {
  'product identifier': {
    pathSuffix: 'product-identifier',
    activeClassList: ['/product-identifier'],
    titleKey: 'DEVORDER_URL.PRODUCT_IDENTIFIER',
    iconClass: 'icon-Inside-Product-Identifier',
    permissionKey: 'productIdentifier',
  },
  'design/details': {
    pathSuffix: 'design-details/list',
    activeClassList: ['/design-details'],
    titleKey: 'DEVORDER_URL.DESIGN_DETAILS',
    iconClass: 'icon-Inside-Details',
    permissionKey: 'design',
    trafficLightKey: 'design',
  },
  bom: {
    pathSuffix: 'bom',
    activeClassList: ['/bom', '/bom-type'],
    titleKey: 'DEVORDER_URL.BOM',
    iconClass: 'icon-Inside-BOM',
    permissionKey: 'bom',
    trafficLightKey: 'bom',
  },
  specifications: {
    pathSuffix: 'measurement',
    activeClassList: ['/measurement'],
    titleKey: 'DEVORDER_URL.SPECIFICATIONS',
    iconClass: 'icon-Inside-Measurements',
    permissionKey: 'measurement',
    trafficLightKey: 'measurement',
  },
  testing: {
    pathSuffix: 'testing/testing-requirements',
    activeClassList: ['/testing', 'testing-group'],
    titleKey: 'DEVORDER_URL.TESTING',
    iconClass: 'icon-Inside-Testing',
    permissionKey: 'testing',
    rightKey: 'TestingRight',
    trafficLightKey: 'testing',
  },
  'care/user instructions': {
    pathSuffix: 'care-user-instruction',
    activeClassList: ['care-user-instruction'],
    titleKey: 'DEVORDER_URL.CARE_USER_INSTRUCTIONS',
    iconClass: 'icon-Inside-User-Instructions',
    permissionKey: 'care',
    trafficLightKey: 'care',
  },
  samples: {
    pathSuffix: 'samples',
    activeClassList: ['sample'],
    titleKey: 'DEVORDER_URL.SAMPLES',
    iconClass: 'icon-Inside-Samples-Icon',
    permissionKey: 'samples',
    trafficLightKey: 'samples',
  },
  'product costing': {
    pathSuffix: 'product-costing',
    activeClassList: ['product-costing'],
    titleKey: 'DEVORDER_URL.PRODUCT_COSTING',
    iconClass: 'icon-Inside-Costing',
    permissionKey: 'costing',
    rightKey: 'productCostingRight',
    trafficLightKey: 'costing',
  },
  'purchase orders': {
    pathSuffix: 'product-purchase-order',
    activeClassList: ['product-purchase-order'],
    titleKey: 'DEVORDER_URL.PURCHASE_ORDERS',
    iconClass: 'icon-Inside-Purchase-Order-Preview',
    permissionKey: 'purchaseOrder',
    rightKey: 'purchaseOrderRight',
    trafficLightKey: 'po',
  },
  'digital assets management': {
    pathSuffix: 'digital-assets-management',
    activeClassList: ['digital-assets-management'],
    titleKey: 'DEVORDER_URL.DAM',
    iconClass: 'icon-Inside-DAM',
    permissionKey: 'DAM',
    rightKey: 'DAMRight',
  },
  'product listing': {
    pathSuffix: 'product-listing',
    activeClassList: ['/product-listing'],
    titleKey: 'DEVORDER_URL.PRODUCT_LISTING',
    iconClass: 'icon-product-listing-icon',
    permissionKey: 'productListing',
    rightKey: 'ProductListingRight',
  },
};
